import { required } from "vuelidate/lib/validators"; 
const StrIsoIzlemKriterleri = {
  data() {
    return {
      StrIsoIzlemKriterleriData: {
        Kriter: null, 
        Birimids: null,
        No: null,
        Onay: null,
        Surec: null,
      },
      FormDataType: { 
        Kriter: { FieldName: "Kriter", Field: "textarea", FieldTitle: "İzleme Kriteri", FieldType: "text" },
        Birimids: { FieldName: "Birimids", Field: "combobox", FieldTitle: "Sorumlu Birim", ComboDataArray: [] },
        No: { FieldName: "No", Field: "textarea", FieldTitle: "İzleme Kriteri No" }, 
        Surec: { FieldName: "Surec", Field: "textarea", FieldTitle: "Süreç" }, 
      },
    }
  },
  validations: {
    FormData: {
      Kriter: { required },
      Birimids: { required },
      No: { required },
      Surec: { required },
    },
    Filter:{ 
      Kriter: {},
      Birimids: {},
      Durum: {}
    }
  },
  created() {
  /*  let Page = {
      PageNumber: "1",
      PageSize: "9999"
    }
    this.ActionsGet({ "Service": "OBirim", "Page": Page }).then((res) => {

      for (var i = 0; i < res.Data.length; i++) {
        this.FormDataType.Birimids.ComboDataArray.push({ Id: res.Data[i].Id, Value: res.Data[i].BirimAdi })
      }
    }); 
    */

  }
}
export default StrIsoIzlemKriterleri